import React from 'react'
import styled from 'styled-components'
import AntTooltip from 'antd/lib/tooltip'
import { color } from '../styles'
import { useTheme } from '../styles/ThemeContext'

type Props = {
    children: string | JSX.Element | JSX.Element[]
    tipText: string
    placement?: React.ComponentProps<typeof AntTooltip>['placement']
    disabled?: boolean
}

export const Tooltip = (props: Props): JSX.Element => {
    const { children, tipText, placement = 'bottom', disabled } = props
    const theme = useTheme()
    const backgroundHex = color.background.inverted({ theme })
    if (disabled) return <Content>{children}</Content>
    return (
        <Container>
            <AntTooltip title={tipText} color={backgroundHex} placement={placement}>
                <Content>{children}</Content>
            </AntTooltip>
        </Container>
    )
}

const Container = styled.div``

const Content = styled.div``
